import { JsonProperty, JsonObject } from 'json2typescript';
import { Nested, HvlBaseModel, Required } from '@hvlng/framework-bff/core';
import { FileOwnershipModel } from './file-ownership-model';

@JsonObject('KovanHrAttachmentModel')
export class AttachmentModel extends HvlBaseModel {
    @Nested()
    @JsonProperty('file', FileOwnershipModel, true)
    file: FileOwnershipModel = new FileOwnershipModel();

    @Required()
    @JsonProperty('documentTypeId', Number, true)
    documentTypeId: number = null;


}
